'use client'
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { UpdateHypothesisDto, UpdateHypothesisResponse } from '../../lib'
import { methods } from '@/shared/api/constants'
import { objectToFormData } from '@/shared/lib/helpers/object-methods'

const update = async (dto: UpdateHypothesisDto) => {
  const res = await api.json<Partial<UpdateHypothesisResponse>>(API_END_POINTS.hypothesis.update, {
    method: methods.post,
    body: objectToFormData(dto),
  })

  if (res.ok) return res.result
  if (!res.ok) throw new Error(res?.message || res?.error)
}

export default update
